import { useSearchParams } from "next/navigation";
import { use, useMemo } from "react";
import { DUMMY_NAME_DATA, formatName, nameDataFromSearchParams, type DesiredNameFormat, type FallbackNameFormat } from "../utils/name-utils";

export function useName() {
	const searchParamsString = useSearchParams().toString();
	const nameDataPromise = useMemo(()=>nameDataFromSearchParams(searchParamsString), [searchParamsString]);
	return use(nameDataPromise);
}

export function useFormattedName(desiredFormat: DesiredNameFormat, fallbackFormat: FallbackNameFormat) {
	const nameData = useName();
	return formatName(nameData, desiredFormat, fallbackFormat);
}

export function useFormattedNameDummy(desiredFormat: DesiredNameFormat, fallbackFormat: FallbackNameFormat) {
	return formatName(DUMMY_NAME_DATA, desiredFormat, fallbackFormat);
}
